import './css/App.css';
import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import HomePage from './pages/Home/HomePage';
import Footer from "./pages/Navigation/Footer";
import Login from "./pages/Account/Login";
import TermsAndConditions from "./pages/Terms/TermsAndConditions";
import AboutUs from "./pages/AboutUs/AboutUs";
import { UserContextProvider } from "./contexts/UserContext";
import MyAccount from "./pages/Account/MyAccount";
import Logoff from "./pages/Account/Logoff";
import Signup from "./pages/Account/Signup";
import Suggestion from "./pages/Account/Suggestion";
import SearchEvent from "./pages/Search/SearchEvent";
import Help from './pages/Home/Help';
import Landing from './pages/Home/Landing';
import RootPage from "./pages/Root/RootPage";

function App() {
	return (
		<div className="container-fluid">
			<UserContextProvider>
				<Routes>
					<Route path="/" exact element={<RootPage />} />
					<Route path="/home" exact element={<HomePage signedIn={false} />} />
					<Route path="/home_signin" exact element={<HomePage signedIn={true} />} />
					<Route path="/suggest" element={<Suggestion />} />
					<Route path="/search" element={<SearchEvent />} />
					<Route path="/sign_in" element={<Login />} />
					<Route path="/terms" element={<TermsAndConditions isSubmit={false} />} />
					<Route path="/about" element={<AboutUs />} />
					<Route path="/termsSubmit" element={<TermsAndConditions isSubmit={true} />} />
					<Route path="/sign_up" element={<Signup />} />
					<Route path="/my_account" element={<MyAccount />} />
					<Route path="/sign_out" element={<Logoff />} />
					<Route path="/help" element={<Help />} />
					<Route path="/landing" element={<Landing />} />
					<Route path='*' element={<Navigate to="/sign_in" replace />} />
				</Routes>

				<Footer />
			</UserContextProvider>
		</div>
	);
}

export default App;
